var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"charts",class:{nodata_img:_vm.nodata}})}
var staticRenderFns = []

export { render, staticRenderFns }